import { motion } from "framer-motion";

export default function PageHero({ overline, lines, intro, image, imageAlt }) {
  return (
    <section className="bg-brand-night text-brand-bone texture-grain pt-40 pb-24 lg:pb-32 relative overflow-hidden">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-12 gap-16 items-center">
        <div className={image ? "lg:col-span-7" : "lg:col-span-9"}>
          <motion.p
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.05 }}
            className="overline-label text-brand-gold"
            data-testid="page-hero-overline"
          >
            {overline}
          </motion.p>
          <motion.h1
            className="mt-6 font-serif text-5xl sm:text-6xl lg:text-7xl tracking-tight font-medium leading-[0.98]"
            data-testid="page-hero-heading"
          >
            {lines.map((line, i) => (
              <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
                <motion.span
                  className="block will-change-transform"
                  initial={{ y: "115%" }}
                  animate={{ y: "0%" }}
                  transition={{ duration: 1, delay: 0.15 + i * 0.13, ease: [0.22, 1, 0.36, 1] }}
                >
                  {line}
                </motion.span>
              </span>
            ))}
          </motion.h1>
          {intro && (
            <motion.p
              initial={{ opacity: 0, y: 18 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.9, delay: 0.55 }}
              className="mt-8 max-w-xl text-base lg:text-lg font-light leading-relaxed text-brand-bone/70"
              data-testid="page-hero-intro"
            >
              {intro}
            </motion.p>
          )}
        </div>
        {image && (
          <div className="lg:col-span-5 relative hidden lg:block">
            <motion.div
              initial={{ opacity: 0, scale: 0.96 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 1.1, delay: 0.35, ease: [0.22, 1, 0.36, 1] }}
              className="relative"
            >
              <div className="absolute -top-4 -left-4 h-full w-full border border-brand-gold/40" aria-hidden="true" />
              <img src={image} alt={imageAlt} className="relative h-[360px] w-full object-cover" data-testid="page-hero-image" />
            </motion.div>
          </div>
        )}
      </div>
    </section>
  );
}
